export const encryptString = (msg: string): string => {
  // @ts-ignore
  // JSEncrypt provided by jsencrypt script.
  // see _app.tsx
  if (JSEncrypt) {
    // @ts-ignore
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(PUBLIC_KEY);
    return jsEncrypt.encrypt(msg);
  }
  return null;
};

export const decryptString = (encryptedMsg: string): string => {
  // @ts-ignore
  if (JSEncrypt) {
    // @ts-ignore
    const decrypt = new JSEncrypt();
    decrypt.setPrivateKey(PRIVATE_KEY);
    return decrypt.decrypt(encryptedMsg);
  }
  return null;
};

const PUBLIC_KEY =
  'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJ1EgdmMZDvBzRYNfeFDZ5Qux+NqZ6cFyE6D6AYgdWy7b2Zd9ETe7e/dHDbIiBLkB9qBV7BUDWVhQteCMMD1Pe8CAwEAAQ==';
const PRIVATE_KEY =
  'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAKPH6g1gSLZeYfW56l8iUPUrTwfeF+crQwT0FkksnEyW4xPblUxVJp7jeV/YVmrpyoiKgW+DHnNrBU1bc7SmzsH1lmh02U77/PH+Vs5RNA4CPOX2/6oHEBman8RIgrQThqsanjlOA2URAVpPSjzdnA0bUIg4863Db+N7Y3s87hIFAgMBAAECgYAWtNqwLA8oqYEvTi0+L0XGF9EHKDVsKUVLZIPKdVLeE3U8BY93W77U/HiRXy7r96nKsFktmqIYIlhD10/9VbsIUvfQmFZ9gxH/CstucQ1Nf9mf38v75c7Zu1YrnXYue4SsUDsiKLdzul1ttvTg1ud3jHXOKPKCGV8HJq1bW3wgQQJBAPy/Kz79IcOtgjyqv0R3nxQzopRRc9iI0xBCSaRqg8vZwdQO84M4vwFb2mW6xV3qrdZPw/dYA8ePu8OhadeRh10CQQCl45eXmPRuXT0+iAQaqW19FAivQ8Y4JKzeGsopbOKGXGQmgwiZjWIbj2h1r+4tzpryWujrURU43xHctat9m1LJAkBQhVryu1RZcdqvFzrORkng9r5SAE0m7BhJ8sRhZCnO9PYCaCz+XkLD3Q6MIF+mlxCA2XK2R00U896+6Zq9ubhlAkA3SDEsg/xxCwFt5UX43J1wIU0Dm0JjU1WIbsUQKQkUXZXCf8hN45/eL1xQW+CzwzY/rawRP2QjH7OEKcaMhUaBAkBO7KV8QZgrffaNdT1DaqVa1Y9gbKGDZgjfu6Py6VrlcGn6IjF3x6bL9HP7fCIz1K9Ls99WgtBGmOV7uzCbFEiJ';
